import { CaseGranulometry } from '../../../CaseGranulometry';
import { getCaseBasementLevels } from '../getCaseBasementLevels';

export const getCaseBasementLevelsCount = (caseGranulometry: CaseGranulometry): number =>
  getCaseBasementLevels(caseGranulometry).length;
